
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-date-v1',
    templateUrl: './fill-date-v1.component.html'
})
export class FillDateV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public date: string;
    public valid: boolean = false;

    ngOnInit(): void {
        // Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value) {
            this.date = this.fieldSubmission.serialized_value;  // Set the value without triggering the input event
            this.valid = this.date !== null; // Update validity
        }
        this.emitValidity();
    }

    onDateSelect(date: string) {
        this.date = date;
        this.valid = true;
        // console.log(" date value selected",date);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: date});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }
}   